const questionTextTemplate = ({questionText, correctAnswerText}) => `<div>
   <p>${questionText}</p>
   ${correctAnswerText ? `<span class="sr-only">${correctAnswerText}</span>` : ''}
</div>`;

export default questionTextTemplate;


